module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.documents) ? _c('f7-list', {
    staticClass: "itemList",
    attrs: {
      "accordion-list": "",
      "id": "payments-item-received"
    }
  }, _vm._l((_vm.documents), function(document) {
    return _c('f7-accordion-item', {
      key: document.id,
      staticClass: "accordionForm",
      on: {
        "accordion:opened": function($event) {
          return _vm.readReport(document)
        }
      }
    }, [_c('f7-accordion-toggle', {
      staticClass: "accordionToggle"
    }, [_c('ul', [_c('li', {
      staticClass: "swipeout"
    }, [_c('div', {
      staticClass: "item-content boxRequest"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('div', {
      style: ({
        background: _vm.rectangleColor
      }),
      attrs: {
        "id": "greenRectangle"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon list-icon",
      class: _vm.getIcon(document.Status)
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('table', {
      staticStyle: {
        "table-layout": "fixed"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "35%",
        "min-width": "35%",
        "max-width": "35%"
      }
    }, [_c('div', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.getDocumentLabel(document)) + "\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "35%",
        "min-width": "35%",
        "max-width": "35%"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDocumentType(document)) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly",
      staticStyle: {
        "width": "30%",
        "min-width": "30%",
        "max-width": "30%"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDate(document)) + "\n                  ")])]), _vm._v(" "), _c('tr', {
      staticClass: "documentListUnderTitle"
    }, [_c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "showSmallScreenOnly"
    }, [_vm._v("\n                      " + _vm._s(_vm.getDocumentType(document)) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                      " + _vm._s(_vm.getStatusLabel(document.Status, document.Role)) + "\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                    " + _vm._s(document.Role.toString() === '1' ? _vm.$t('common.to_label') : _vm.$t('common.from_label')) + "\n                    " + _vm._s(' : ' + document.Correspondent) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "rowspan": "2"
      }
    }, [(_vm.showValidationButtons(document.Status, document.Role)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.updateDecision($event, document, 'ACCP')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-accept-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('common.accpt')) + "\n                      ")]), _vm._v("\n                       \n                      "), _vm._v(" "), _c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.updateDecision($event, document, 'RFSL')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-reject-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('common.refus')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.showValidationButtonsLevel2(document.Status)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.updateDecisionLevel2($event, document, 'ACCP')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-accept-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('common.accpt')) + "\n                      ")]), _vm._v("\n                       \n                      "), _c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.updateDecisionLevel2($event, document, 'RFSL')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-reject-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('common.refus')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.showPayButtons(document.Status, document.Role, document.Type)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.payInvoice(document)
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-hand_money"
    }), _vm._v("\n                        " + _vm._s("Payer la facture") + "\n                      ")]), _vm._v("\n                       \n                      "), _c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.closeDocument($event, document)
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-made"
    }), _vm._v("\n                        " + _vm._s("Facture payée") + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.showClosingDocButtons(document.Status, document.Role, document.Type)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.closeDocument($event, document)
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-made"
    }), _vm._v("\n                        " + _vm._s("Facture payée") + "\n                      ")])]) : (_vm.showReturningDocButtons(document.Status, document.Role)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [(_vm.$engine.rights.rightIs('ds_send_document', true)) ? _c('div', {
      staticClass: "documentButton"
    }, [_c('i', {
      staticClass: "icon list-icon icon-return-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('businessDocuments.form_document_send_title')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.$engine.rights.rightIs('ds_request_response_refuser', true)) ? _c('div', {
      staticClass: "documentButton",
      staticStyle: {
        "margin-left": "27px"
      },
      on: {
        "click": function($event) {
          return _vm.updateDecision($event, document, 'RFSL')
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-reject-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('common.refus')) + "\n                      ")]) : _vm._e()]) : (_vm.showAfterCancelDocButtons(document.Status, document.Role)) ? _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "documentButton",
      staticStyle: {
        "margin-left": "-20px"
      },
      on: {
        "click": function($event) {
          return _vm.resendRequest(document)
        }
      }
    }, [_c('i', {
      staticClass: "icon list-icon icon-return-doc"
    }), _vm._v("\n                        " + _vm._s(_vm.$t('businessDocuments.form_document_resend_request_title')) + "\n                      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex"
      }
    }, [_c('div', {
      staticClass: "documentButton",
      on: {
        "click": function($event) {
          return _vm.createReminder($event, document)
        }
      }
    }, [_vm._v("\n                        " + _vm._s("Create Reminder") + "\n                      ")])])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detailsDocumentStatus showSmallScreenOnly"
    }, [_vm._v("\n                    " + _vm._s(_vm.getStatusLabel(document.Status, document.Role)) + "\n                  ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "showSmallScreenOnly",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getDate(document)) + "\n                  ")])])])])])])])]), _vm._v(" "), (document.Serialize) ? _c('f7-accordion-content', {
      staticClass: "background-document-form left-box"
    }, [(_vm.showReturningDocButtons(document.Status, document.Role)) ? _c('business-document-return-form', {
      attrs: {
        "document": document,
        "cloudDocs": _vm.cloudFilesList
      },
      on: {
        "reloadFolder": function($event) {
          return _vm.getDocumentDetails(document.IdDocument)
        }
      }
    }) : _c('business-document-details-list', {
      attrs: {
        "document": document
      }
    })], 1) : _vm._e()], 1)
  }), 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-87d3252c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87d3252c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentList.vue
// module id = 2417
// module chunks = 2